'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignLeft = function EditorFormatAlignLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignLeft = (0, _pure2.default)(EditorFormatAlignLeft);
EditorFormatAlignLeft.displayName = 'EditorFormatAlignLeft';
EditorFormatAlignLeft.muiName = 'SvgIcon';

exports.default = EditorFormatAlignLeft;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/format-align-left.js
// module id = 2227
// module chunks = 0